import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO() {
  // Keywords organized by category for SEO optimization
  const keywords = [
    // Primary Location Keywords
    "Primary Care Frederick MD",
    "Family Doctor Frederick",
    "Medical Practice Frederick MD",
    "Doctor's Office Frederick MD",
    "Healthcare Frederick Maryland",
    "Primary Care Provider Frederick",
    "Accepting New Patients Frederick",
    "Thomas Johnson Drive Medical Office",

    // Specialty Keywords
    "Obesity Medicine Frederick MD",
    "Weight Management Doctor Frederick",
    "Medical Weight Loss Frederick",
    "Metabolic Health Frederick",
    "Internal Medicine Frederick MD",
    "Board Certified Physicians Frederick",
    "Female Doctors Frederick MD",
    
    // Condition-Specific Keywords
    "Diabetes Management Frederick",
    "Metabolic Disorders Treatment",
    "Type 2 Diabetes Care Frederick",
    "Metabolic Syndrome Treatment",
    "Weight Loss Programs Frederick",
    "Obesity Specialist Frederick",
    "High Blood Pressure Treatment",
    "Cholesterol Management",
    
    // Treatment Keywords
    "Blood Sugar Management Frederick",
    "Weight Loss Consultation Frederick",
    "Obesity Care Frederick MD",
    "Medical Weight Management",
    "Preventive Care Frederick",
    "Annual Physical Exams",
    "Chronic Disease Management",
    
    // Service-Specific Keywords
    "Same Day Appointments Frederick",
    "Primary Care Services",
    "Preventive Medicine Frederick",
    "Metabolic Testing Frederick",
    "Lifestyle Medicine Frederick",
    "Medical Nutrition Therapy",
    "Women's Health Services",
    "Geriatric Care Frederick"
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Frederick Metabolic & Primary Care Associates",
    "image": "https://www.metabolicandprimarycare.com/FMPCA Logo3-og.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "184 Thomas Johnson Drive, Suite 201",
      "addressLocality": "Frederick",
      "addressRegion": "MD",
      "postalCode": "21701",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "39.4003",
      "longitude": "-77.4011"
    },
    "url": "https://www.metabolicandprimarycare.com",
    "telephone": "240-949-7519",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "medicalSpecialty": [
      "Primary Care",
      "Internal Medicine",
      "Obesity Medicine",
      "Preventive Medicine",
      "Women's Health",
      "Geriatric Care"
    ],
    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Primary Care Services"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Obesity Management"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Preventive Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Chronic Disease Management"
      }
    ],
    "keywords": keywords.join(", ")
  };

  // Add more structured data
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Frederick Metabolic & Primary Care Associates",
    "image": "https://www.metabolicandprimarycare.com/FMPCA Logo3-og.png",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "184 Thomas Johnson Drive, Suite 201",
      "addressLocality": "Frederick",
      "addressRegion": "MD",
      "postalCode": "21701",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "39.4003",
      "longitude": "-77.4011"
    },
    "telephone": "240-949-7519",
    "url": "https://www.metabolicandprimarycare.com",
    "sameAs": [
      "https://www.facebook.com/yourpage",
      "https://www.linkedin.com/company/yourpage"
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "medicalSpecialty": [
      "Primary Care",
      "Internal Medicine",
      "Obesity Medicine"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <meta name="keywords" content={keywords.join(", ")} />
    </Helmet>
  );
} 